export default __webpack_public_path__ + "assets/b109caa87aab97d1327438d8a20f31d9.jpg";